import VerifyCode from './VerifyCode.jsx'

export default VerifyCode